<template>
  <password-success v-if="success" @close="$emit('closeDialog')" />
  <profile-password-form-invira v-else @success="success = true" @close="$emit('closeDialog')" />
</template>

<script>
import ProfilePasswordFormInvira from './ProfilePasswordFormInvira.vue';
import PasswordSuccess from '@dracul/user-frontend/src/pages/ProfilePage/ProfilePassword/ProfilePasswordSuccess.vue';

export default {
  name: 'ProfilePasswordInvira',
  components: {
    ProfilePasswordFormInvira,
    PasswordSuccess,
  },
  data() {
    return {
      success: false,
    };
  },
};
</script>
